import styled from 'styled-components';

type VerifyMaskedPhonePreviewProps = {
  subtitleText: string;
  phonePreview: string;
};

const MaskedPhoneSymbol = styled.span`
  font-family: Rubik, sans-serif;
`;

export function VerifyMaskedPhonePreview({
  subtitleText,
  phonePreview,
}: VerifyMaskedPhonePreviewProps) {
  const phoneStartIndex = subtitleText.indexOf(phonePreview);
  if (phoneStartIndex === -1) {
    return subtitleText;
  }

  const prefix = subtitleText.slice(0, phoneStartIndex);
  const suffix = subtitleText.slice(phoneStartIndex + phonePreview.length);

  return (
    <>
      {prefix}
      {Array.from(phonePreview).map((symbol, index) => {
        if (symbol !== '*') {
          return symbol;
        }

        return (
          <MaskedPhoneSymbol key={`masked-phone-symbol-${index}`}>
            {symbol}
          </MaskedPhoneSymbol>
        );
      })}
      {suffix}
    </>
  );
}
